import React, { ReactNode } from 'react'

import { combineClassnames } from 'app/common/presentation'

import styles from './Button.module.scss'

interface ButtonProps
  extends Pick<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'children' | 'className' | 'disabled' | 'onClick' | 'type'
  > {
  destructive?: boolean
  leftIcon?: ReactNode
  loading?: boolean
  rightIcon?: ReactNode
  small?: boolean
  variant?: 'primary' | 'primary-gray' | 'secondary' | 'outlined' | 'tertiary'
}

const Button = ({
  className,
  children,
  destructive,
  disabled,
  leftIcon,
  loading,
  rightIcon,
  small,
  type = 'button',
  variant = 'primary',
  ...otherProps
}: ButtonProps) => {
  const variantClass = variant === 'outlined' ? styles.secondary : styles[`${variant}`]

  return (
    <button
      className={combineClassnames(
        styles.button,
        small ? styles.small : undefined,
        variantClass,
        destructive ? styles.destructive : undefined,
        loading ? styles.loading : undefined,
        className,
      )}
      data-testid="button"
      disabled={disabled ?? loading}
      type={type}
      {...otherProps}
    >
      {leftIcon}
      <span className={styles.label}>{children}</span>
      {rightIcon}
    </button>
  )
}

export default Button
